import { render, staticRenderFns } from "./workLeaveModal.vue?vue&type=template&id=11efb885&"
import script from "./workLeaveModal.vue?vue&type=script&lang=js&"
export * from "./workLeaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports